/* eslint-disable import/prefer-default-export */
const SIDEBAR_WIDTH = 269;

export { SIDEBAR_WIDTH };
